<div class="container-modal">
    <div class="container-modal__wrapper">
        <ng-container>
            <h1 class="title">
                <ng-container *ngIf="isError">
                    {{'errorChangeBlockedStatus'|translate}}
                </ng-container>
                <ng-container *ngIf="!isError">
                    {{ isLoading ? (data?.Value ? ('blockedInProgress'|translate) : ('blockedOffInProgress'|translate)) : (data?.Value ? ('confirmBlockedOn'|translate) : ('confirmBlockedOff'|translate)) }}
                </ng-container>
            </h1>
            <span class="description">
                <ng-container *ngIf="isError">
                    {{'errorChangeBlockedDescription'|translate}}
                </ng-container>
                <ng-container *ngIf="!isError">
                    {{ isLoading ? ('changeBlockedDescription' | translate) : '' }}

                    <span *ngIf="!isLoading && data.Value">
                        {{'descriptionBlockedOn'|translate}} <span class="gold">{{'descriptionBlockedOnPart2'|translate}}</span>
                    </span>
                </ng-container>
            </span>
            <div class="actions">
                <app-button
                    (click)="submit()"
                    [isLoading]="isLoading"
                    [isFullWidth]="true"
                    [ngClass]="{'is-loading': isLoading}"
                    colorSpinner="#FFF"
                    [label]="isError ? ('tryAgain'|translate) : (data.Value ? ('blockedConfirmSubmit'|translate) : ('blockedConfirmOff'|translate))"
                    class="actions__submit"
                >
                </app-button>
                <app-button
                    *ngIf="!isLoading"
                    [label]="'labels.cancel'|translate"
                    class="actions__cancel"
                    (click)="cancel()"
                >
                </app-button>
            </div>
        </ng-container>
    </div>
</div>